import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { staffLogOutApi } from "../../api/staff";
import logo from '../../assets/images/Logo.png'
import toast from "react-hot-toast";
import { HomeIcon } from "../icons/SVG";
import useAuth from "../../hooks/useAuth";
import StaffActionPinModal from "../dialog/StaffActionPinModal";

function Nav(){
    const navigate = useNavigate(); 
    const { user } = useAuth();
    const restaurant_system_id = useAuth()?.user?.restaurant_system_id;

    // Staff Break / Clock-Out PIN Modal
    const [staffModalOpen, setStaffModalOpen] = useState(false);
    const [staffActionType, setStaffActionType] = useState("break_in");
    const [isOnBreak, setIsOnBreak] = useState(() => {
        const userId = user?.system_id || user?.id;
        return userId ? localStorage.getItem(`is_on_break_${userId}`) === "true" : false;
    });

    useEffect(() => {
        const userId = user?.system_id || user?.id;
        if (userId) {
            setIsOnBreak(localStorage.getItem(`is_on_break_${userId}`) === "true");
        }
    }, [user]);

    const handleBreakClick = () => {
        setStaffActionType(isOnBreak ? "break_out" : "break_in");
        setStaffModalOpen(true);
    };

    const handleClockOutClick = () => {
        setStaffActionType("clock_out");
        setStaffModalOpen(true);
    };

    const handleStaffActionSuccess = (res, actionType) => {
        const userId = user?.system_id || user?.id;
        if (actionType === "break_in") {
            setIsOnBreak(true);
            if (userId) localStorage.setItem(`is_on_break_${userId}`, "true");
        } else if (actionType === "break_out") {
            setIsOnBreak(false);
            if (userId) localStorage.setItem(`is_on_break_${userId}`, "false");
        }
    };
    
    function logOut(){

        localStorage.removeItem("token")
        localStorage.removeItem("user")
        localStorage.removeItem("tags")
        navigate("/")

        staffLogOutApi({ restaurant_system_id }).then((data)=>{  
           if(data?.status == "success"){
            toast.success("Logout Successfully.")
           }else{
            toast.error(data?.message)
            console.log(data)
           }
        })
    }

    return(
            <div className=" bg-color1 col-span-20 row-span-1 flex pl-4">
                <div className=" w-[40%] flex items-center gap-20">
                    <Link to="/home" >
                        <img className=" w-[150px] " src={logo} alt="" />
                    </Link>
                    <Link to="/home" className="px-3 py-1 bg-cyan-700 rounded-md flex items-center justify-center gap-2 text-color5">
                        <HomeIcon />
                        <span className=" text-xl">Home</span>

                    </Link>
                </div>
                <div className=" w-[60%] flex items-center justify-between gap-4">
                    <div className=" flex gap-4">
                        <Link to="/take-order" className=" px-2 py-1 bg-color6 text-color1 rounded-md flex items-center">Take Order</Link>
                        <button onClick={handleBreakClick} className={` px-2 py-1 rounded-md transition-all ${isOnBreak ? "bg-amber-500 text-black font-semibold" : "bg-color3 text-color5"}`}>
                            {isOnBreak ? "Break-Out" : "Break-In"}
                        </button>
                        <button onClick={handleClockOutClick} className=" px-2 py-1 bg-color3 text-color5 rounded-md hover:bg-rose-900 transition-all">Clock-out</button>
                        <button onClick={logOut} className=" px-2 py-1 bg-color3 text-color5 rounded-md">Off mode</button>
                    </div>
                    <div className=" w-[200px] flex items-center justify-center gap-4">
                        <div className=" w-10 h-10 bg-color6 rounded-full flex items-center justify-center text-3xl">
                            <span>{user?.name?.[0]}</span>
                        </div>
                        <div className=" text-color5 flex flex-col items-center justify-center">
                            <span className=" font-semibold">{user?.name}</span>
                            <span className=" text-sm capitalize">{user?.designation || "N/A"}</span>
                        </div>
                    </div>
                </div>

                <StaffActionPinModal
                    isOpen={staffModalOpen}
                    onClose={() => setStaffModalOpen(false)}
                    actionType={staffActionType}
                    user={user}
                    restaurantId={restaurant_system_id}
                    onSuccess={handleStaffActionSuccess}
                />
            </div>
    )
}

export default Nav;